import { aboutInfo } from '@/mocks/homeData';

export default function SectionAbout() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-3/5 flex flex-col gap-5">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
              {aboutInfo.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {aboutInfo.desc1}
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {aboutInfo.desc2}
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4 mt-2">
              {aboutInfo.values.map((v) => (
                <div key={v.label} className="text-center p-4 rounded-xl bg-background-50 border border-background-200/60">
                  <div className="text-xl md:text-2xl font-heading text-primary-500 mb-1">
                    {v.value}
                  </div>
                  <div className="text-xs text-foreground-500">{v.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="w-full lg:w-2/5">
            <div className="rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 p-6 md:p-8">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center">
                  <i className="ri-chat-smile-2-line text-primary-600 text-lg"></i>
                </div>
                <span className="text-lg font-heading text-foreground-900">我们的初心</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                我们是一群热爱漫画的创作者和工程师，希望用技术的力量让漫画阅读回归纯粹。没有烦人的广告弹窗，没有复杂的付费机制，只有好漫画和热爱漫画的你。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}